/**
 * Call to Action - Go to Event
 * --------------------------------
 *
 * Expected variables: none
 */

import View from 'view/view'
import template from 'component/cta/go_to_events/template.tmpl'
import Router from 'service/router'
import dataProvider from 'service/data_provider'
import assets from 'service/assets'

const CreateActivityView = View.extend({
    template,
    render() {
        this.$el.html(
            this.template({
                img: assets.getStaticImageUrl('/ui/empty-states/no-events-v1.svg'),
                isLoggedIn: Boolean(dataProvider.get('currentUser')),
                link: {
                    events: Router.path('calendar_discovery_events_index', null, { query: { ref: 'gra_ua_fe' } }),
                },
            })
        )

        return this
    },
})

export default CreateActivityView
